var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticStyle:{"padding":"20px","font-size":"22px","font-weight":"500"}},[_vm._v(" 首页 ")])])}]

export { render, staticRenderFns }